/**
 * Build-time feature flags (Phase 2 §7 rollback, U0.3).
 *
 * Both are read from the build environment by their exact names, which
 * `vite.config.ts` exposes through `envPrefix`; nothing else in the
 * `FLOWSTACK_*` namespace reaches the bundle. A flag is a string at build
 * time, so the comparison is on the text, case-insensitively.
 *
 * - `FLOWSTACK_WORKBENCH_ENABLED` — the project workbench and the links into
 *   it. **On unless set to `false`**: turning it off restores the Phase-1
 *   submit pages as the only way in, which keep working throughout (the
 *   workbench links to them, it does not replace them).
 * - `FLOWSTACK_ASSISTANT_ENABLED` — the workbench's Assistant panel, a
 *   disabled placeholder reserved for Phase 3. **Off unless set to `true`.**
 *
 * Each flag leaves its default only on the one word that names the other
 * state, so `1`, `off` or a typo keeps the default rather than flipping it.
 *
 * Functions rather than constants so a test can `vi.stubEnv` either flag.
 */

function flag(value: string | undefined, fallback: boolean): boolean {
  const opposite = fallback ? "false" : "true";
  return value?.trim().toLowerCase() === opposite ? !fallback : fallback;
}

export function workbenchEnabled(): boolean {
  return flag(import.meta.env.FLOWSTACK_WORKBENCH_ENABLED, true);
}

export function assistantEnabled(): boolean {
  return flag(import.meta.env.FLOWSTACK_ASSISTANT_ENABLED, false);
}
